/**
 * MBMC Theme Animations
 * Handles scroll-triggered reveal animations and interactive hover effects across Home, Party, and Workshop pages.
 */
document.addEventListener('DOMContentLoaded', function () {
  // Elements to observe for scroll animation
  const animatableSelectors = [
    '.mbmc-section',
    '.mbmc-pf-celebrations',
    '.mbmc-pf-scents',
    '.mbmc-pf-customize',
    '.mbmc-pf-order',
    '.mbmc-pf-testimonials',
    '.mbmc-pf-timeline',
    '.mbmc-pf-faq',
    '.mbmc-pf-cta',
    '.mbmc-ws-spot',
    '.mbmc-ws-provided',
    '.mbmc-ws-process',
    '.mbmc-ws-outcomes',
    '.mbmc-ws-testimonials',
    '.mbmc-ws-faq',
    '.mbmc-ws-cta',
    '.mbmc-ws-also',
    '.mbmc-collection-card',
    '.mbmc-shampoo-card',
    '.mbmc-beyond-card',
    '.mbmc-standard-card',
    '.mbmc-review-card',
    '.mbmc-pf-scent',
    '.mbmc-pf-acc',
    '.mbmc-pf-step',
    '.mbmc-pf-customize__card',
    '.mbmc-ws-card',
    '.mbmc-ws-step',
    '.mbmc-ws-outcome',
    '.mbmc-ws-stat',
    '.mbmc-ws-hero__badge'
  ].join(',');

  const elements = document.querySelectorAll(animatableSelectors);

  // Add base scroll animation class
  elements.forEach(function (el) {
    if (!el.classList.contains('mbmc-scroll-ready')) {
      el.classList.add('mbmc-scroll-ready');
      
      // Calculate stagger for grid children if applicable
      const parentGrid = el.parentElement;
      if (parentGrid && (parentGrid.classList.contains('mbmc-scroll-row') || 
          parentGrid.classList.contains('mbmc-pf-scents__grid') || 
          parentGrid.classList.contains('mbmc-ws-provided__grid') ||
          parentGrid.classList.contains('mbmc-ws-process__grid') ||
          parentGrid.classList.contains('mbmc-ws-outcomes__grid'))) {
        const childIndex = Array.from(parentGrid.children).indexOf(el);
        if (childIndex > 0) {
          el.style.transitionDelay = (childIndex * 0.08) + 's';
        }
      }
    }
  });

  // IntersectionObserver
  if ('IntersectionObserver' in window) {
    const scrollObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mbmc-in-view');
            scrollObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    elements.forEach(function (el) {
      scrollObserver.observe(el);
    });
  } else {
    // Fallback if IntersectionObserver is unsupported
    elements.forEach(function (el) {
      el.classList.add('mbmc-in-view');
    });
  }

  // Trigger hero animation immediately on load
  setTimeout(function () {
    document.querySelectorAll('.mbmc-hero, .mbmc-pf-hero, .mbmc-ws-hero').forEach(function (hero) {
      hero.classList.add('mbmc-hero-animated');
    });
  }, 100);
});
